import { render, staticRenderFns } from "./hetongbao.vue?vue&type=template&id=6d8d8138&scoped=true"
import script from "./hetongbao.vue?vue&type=script&lang=js"
export * from "./hetongbao.vue?vue&type=script&lang=js"
import style0 from "./hetongbao.vue?vue&type=style&index=0&id=6d8d8138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8d8138",
  null
  
)

export default component.exports